import React from "react";
export const darkenColor = (hex, amount = 20) => {
  let col = hex.replace("#", "");
  let num = parseInt(col, 16);

  let r = (num >> 16) - amount;
  let g = ((num >> 8) & 0x00FF) - amount;
  let b = (num & 0x0000FF) - amount;

  r = r < 0 ? 0 : r;
  g = g < 0 ? 0 : g;
  b = b < 0 ? 0 : b;

  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, "0")}`;
};

export const RecentSliderSettings = {
  dots: false,
  infinite: false,
  autoplay:false,
  slidesToShow: 8.8,
  slidesToScroll: 2,
  swipeToSlide: false,
  focusOnSelect: true,
  touchMove: true,
  touchThreshold: 15,
  responsive: [
    { breakpoint: 1600, settings: { slidesToShow: 4.9 } },
    { breakpoint: 1200, settings: { slidesToShow: 4.5 } },
    { breakpoint: 991, settings: { slidesToShow: 3.6 } },
    { breakpoint: 767, settings: { slidesToShow: 2.6 } },
    { breakpoint: 576, settings: { slidesToShow:2.2 } },
    { breakpoint: 400, settings: { slidesToShow: 1.9 } },
    { breakpoint: 390, settings: { slidesToShow: 1.7 } }
  ],
};
const RecentCard = ({ item, IconComp }) => {
  return (
    <div className="recent-card-main">
      <div
        className="custom-card h-auto"
        style={{
          background: item.color,
          border: `1px solid ${darkenColor(item.color, 30)}`,
          overflow: "hidden",
          borderRadius: "5px",
        }}
      >
        {/* SVG ABOVE ALL CONTENT */}
        <div className="card-svg-top">
          <IconComp />
        </div>

        {/* CONTENT */}
       <div className="card-content recent-content">

          {/* Title & Count */}
          <div className="recentActivity">
            <h6 className="fw-semibold small mb-0 blackText">{item.title}</h6>           
          </div>

          {/* PROGRESS BAR */}
          <div className="progress recent-progress" style={{ height: "2px" }}>
            <div
              className="progress-bar bg-primary"
              style={{ width: item.progress + "%" }}
            ></div>
          </div>

          <p className="fw-semibold mb-0 text-purple recent-count">{item.count}</p>
          
        </div>
      </div>
    </div>
  );
};

export default RecentCard;